/* eslint-disable import/prefer-default-export */
import * as React from 'react'

export const usePrevious = <T extends any>(value: T): T => {
  const ref = React.useRef<T>()
  React.useEffect(() => {
    ref.current = value
  })
  return ref.current
}
